
import { MainLayout } from "@/components/layout/MainLayout";

export default function QAForum() {
  return (
    <MainLayout>
      <div className="space-y-6">
        <h1 className="text-3xl font-bold">Φόρουμ Συζητήσεων</h1>
        <p className="text-muted-foreground mb-6">
          Συζητήσεις μεταξύ των μελών της κοινότητας για διάφορα θέματα.
        </p>
        
        <div className="flex justify-between items-center mb-4">
          <div className="flex gap-2">
            <button className="px-3 py-1 text-sm bg-primary text-primary-foreground rounded-md">Όλα</button>
            <button className="px-3 py-1 text-sm bg-muted text-muted-foreground rounded-md">Προγραμματισμός</button>
            <button className="px-3 py-1 text-sm bg-muted text-muted-foreground rounded-md">Web</button>
            <button className="px-3 py-1 text-sm bg-muted text-muted-foreground rounded-md">Βάσεις Δεδομένων</button>
          </div>
          <button className="px-3 py-1 text-sm border border-input rounded-md hover:bg-accent transition-colors">
            Νέα συζήτηση
          </button>
        </div>
        
        <div className="space-y-4">
          {[1, 2, 3, 4, 5].map((i) => (
            <div key={i} className="border rounded-lg p-4 hover:shadow-md transition-shadow">
              <div className="flex justify-between items-start mb-2">
                <h3 className="font-semibold">Θέμα συζήτησης {i}: Ανάπτυξη εφαρμογών με React</h3>
                <span className="px-2 py-1 bg-muted text-xs rounded-full">
                  Προγραμματισμός
                </span>
              </div>
              <p className="text-xs text-muted-foreground mb-3">
                Ξεκίνησε από: Χρήστης{i} • 10/06/2023 • Τελευταία απάντηση: 14/06/2023
              </p>
              <p className="text-sm text-muted-foreground mb-3">
                Σύντομη περιγραφή της συζήτησης σχετικά με την ανάπτυξη εφαρμογών με React...
              </p>
              <div className="flex justify-between items-center">
                <div className="flex items-center gap-4">
                  <div className="flex items-center gap-1">
                    <MessageIcon className="h-4 w-4 text-muted-foreground" />
                    <span className="text-xs text-muted-foreground">{i * 3 + 2}</span>
                  </div>
                  <div className="flex items-center gap-1">
                    <EyeIcon className="h-4 w-4 text-muted-foreground" />
                    <span className="text-xs text-muted-foreground">{i * 15 + 10}</span>
                  </div>
                </div>
                <button className="text-primary text-sm hover:underline">Προβολή</button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </MainLayout>
  );
}

function MessageIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
    </svg>
  );
}

function EyeIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      <path d="M2 12s3-7 10-7 10 7 10 7-3 7-10 7-10-7-10-7Z" />
      <circle cx="12" cy="12" r="3" />
    </svg>
  );
}
